import React from "react"
import PropTypes from "prop-types"

import appStorage from "../../app-settings/index.es6"
import Link from "../../links/index.jsx"

import styles from "./index.less"

const AlertContentSelect = ({ pageCount, totalCount, onSelectionApply }) => {
  const selectedText = appStorage
    .translationFunction("Framework.TableSelectionHint:AllPageRowsSelected")
    .split("{0}")

  const applyText = appStorage
    .translationFunction("Framework.TableSelectionHint:SelectAllInTable")
    .split("{0}")

  return (
    <div>
      <span>
        {selectedText[0]} <span className={styles.bold}>{pageCount}</span>
        {` ${selectedText[1]} `}
      </span>

      <Link onClick={onSelectionApply} className={styles.bold}>
        {applyText[0]} <span>{totalCount}</span> {applyText[1]}
      </Link>
    </div>
  )
}

const AlertContentUndo = ({ totalCount, onSelectionUndo }) => {
  const selectedText = appStorage
    .translationFunction("Framework.TableSelectionHint:AllTableRowsSelected")
    .split("{0}")

  const undoText = appStorage.translationFunction("Framework.TableSelectionHint:UndoTheSelection")

  return (
    <div>
      <span>
        {selectedText[0]} <span className={styles.bold}>{totalCount}</span>
        {` ${selectedText[1]} `}
      </span>

      <Link onClick={onSelectionUndo} className={styles.bold}>
        {undoText}
      </Link>
    </div>
  )
}

const SelectionHint = (props) => {
  const { isShown, isTotalSelectionApplied, colSpan } = props

  if (!isShown) return null

  return (
    <tr>
      <th colSpan={colSpan}>
        <div className={styles.selectAllLine}>
          {isTotalSelectionApplied ? (
            <AlertContentUndo {...props} />
          ) : (
            <AlertContentSelect {...props} />
          )}
        </div>
      </th>
    </tr>
  )
}

SelectionHint.propTypes = {
  isShown: PropTypes.bool.isRequired,
  isTotalSelectionApplied: PropTypes.bool.isRequired,
  pageCount: PropTypes.number.isRequired,
  totalCount: PropTypes.number.isRequired,
  onSelectionApply: PropTypes.func,
  onSelectionUndo: PropTypes.func,
  colSpan: PropTypes.number,
}

export default SelectionHint
